import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { InitAccountDrawer } from "./InitAccountDrawer";

export const CustomerManage = () => {

    return (
        <>
            <PageHeader />
            <DataBox />
            <InitAccountDrawer />
        </>
    )
}